import React from 'react';
import PropTypes from 'prop-types';

import { long } from '../common/formatting/date';

const CareQuestPanel = ({ response, onReply, onAcknowledge }) => {
	return (
		<div className="panel panel-default" key={response.care_quest_response_groupId}>
			<div className="panel-body">
				<h1>{response.name_first} {response.name_last}</h1>
				<h4>Care Plan: {response.care_quest_group_name} form submitted. One or more responses are considered high risk.</h4>
				{response.response_dttm ? <p>{long(response.response_dttm)}</p> : null}
			</div>
			<div className="panel-footer text-right">
				<button
					type="button"
					className="btn btn-primary"
					onClick={() => onReply(response)}
				>Respond to Patient</button>
				<button
					type="button"
					className="ml-sm btn btn-danger"
					onClick={() => onAcknowledge(response.care_quest_response_groupId)}
				>Acknowledge &amp; Close</button>
			</div>
		</div>
	);
};

CareQuestPanel.propTypes = {
	response: PropTypes.object,
	onReply: PropTypes.func.isRequired,
	onAcknowledge: PropTypes.func.isRequired
};

export default CareQuestPanel;
